import { createApp } from 'vue'
import i18nPlugin, { i18n, loadTranslations } from '../../i18n'
import ShopifyAdjustTagsModal from '../../components/shopify/adjust-tags-modal.vue'

$.onmount('[data-vue=shopify-adjust-tags]', async function () {
  const initialData = JSON.parse(this.attributes['data-initial-data'].value)

  const app = createApp(ShopifyAdjustTagsModal, { initialData })

  app.use(i18nPlugin)

  await loadTranslations(i18n)

  app.mount(this)
})
